import { createFileRoute } from "@tanstack/react-router"

import { PageHeader } from "@/components/common/page-header"
import { RequestsActions } from "@/features/requests/components/requests-actions"
import { RequestsWaiting } from "@/features/requests/components/requests-waiting"
import { requestQueries } from "@/queries/requests"

export const Route = createFileRoute(
  "/$organisation/_authenticated/_organisation/_main/requests/"
)({
  loader: ({ context }) =>
    context.queryClient.ensureQueryData(requestQueries.waiting()),
  component: RequestsPage,
})

function RequestsPage() {
  return (
    <>
      <PageHeader title="Requests" actions={<RequestsActions />} />
      <RequestsWaiting />
    </>
  )
}
